import { resolveReportFilterPanel } from '@/modules/reports/directives/reportFilterPanelSync';
angular.module('leanlaw').controller('GenericReportMainCtrl', ['$scope', '$rootScope', '$filter', '$stateParams', '$state', "alerts", 'userService', 'reportDefinitions', 'reportFilterService', "exportJson", "lists", 'leanLawAuth', function ($scope, $rootScope, $filter, $stateParams, $state, alerts, userService, reportDefinitions, reportFilterService, exportJson, lists, leanLawAuth) {
  $scope.vm = {
    me: undefined,
    loading: true,
    filter: reportFilterService.getFilterState(),
    initialDateRange: $stateParams.dateRangeId,
    // the report structure
    menu: undefined,
    structure: undefined,
    returnLabel: undefined,
    // the table data to be showns (rows/values)
    data: undefined,
    // derived view state, recomputed when the filter/search/sort change
    columns: [],
    totalColumns: [],
    filtered: [],
    // current sort info
    sort: undefined,
    reverse: undefined
  };
  const billedOptions = lists.billedOptions;
  $scope.getDateRange = function () {
    const filter = reportFilterService.getFilterState();
    if (!filter) return;
    if (!$scope.vm.structure) return;
    const {
      showFilters
    } = $scope.vm.structure;
    if (!showFilters.dateRange) return;
    if (filter.dateRange?.label == "All Time") return "All Time";
    if (!filter.dateRange.range) return;
    return `${formatDate(filter.dateRange.range.startDate)} - ${formatDate(filter.dateRange.range.endDate)}`;
  };
  $scope.getBilledStatus = function () {
    const filter = reportFilterService.getFilterState();
    if (!filter) return;
    if (!$scope.vm.structure) return;
    const {
      showFilters
    } = $scope.vm.structure;
    if (!showFilters.billed) return;
    const billed = filter.billed.id;
    return billedOptions.find(option => option.id === billed)?.label;
  };
  $scope.getArchivedLabel = function () {
    const filter = reportFilterService.getFilterState();
    if (!$scope.vm.structure) return;
    const {
      showFilters
    } = $scope.vm.structure;
    const showArchivedStatus = showFilters.archivedStatus || showFilters.matterForUser;
    if (!showArchivedStatus) return;
    return filter.status.label;
  };
  $scope.getTrustAccountLabel = function () {
    const filter = reportFilterService.getFilterState();
    if (!$scope.vm.structure) return;
    const {
      showFilters
    } = $scope.vm.structure;
    const showTrustAccountName = showFilters.trustAccount;
    if (!showTrustAccountName) return;
    return filter?.trustAccount?.name;
  };
  $scope.print = function () {
    window.print();
  };
  $scope.export = exportReport;
  $scope.select = selectRow;
  $scope.goback = goback;
  $scope.filterChanged = filterChanged;
  activate();

  ///////////////////////////////////////

  let _params;
  $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
    if (fromState.name === "reports.generic.charges" || fromState.name === "reports.generic.expenses" || fromState.name === "reports.generic.entry" || fromState.name === "reports.generic.entry2") {
      const {
        data
      } = $scope.vm;
      $scope.vm.report?.definition?.selectDone({
        fromState,
        fromParams
      }).then(({
        item,
        id,
        values,
        itemDeleted
      }) => {
        if (itemDeleted) {
          data.rows = data.rows.filter(row => row.item.id !== id);
          formatRows(data);
          updateFiltered();
          return;
        }
        // The value cells are one-time bound, so an edit only shows once ng-repeat
        // rebuilds the row. Deleting $$hashKey is what forces that: ng-repeat tracks
        // rows by it, stores it on the row, and a spread would carry it over and
        // reuse the old block.
        data.rows = data.rows.map(row => {
          if (row.item.id !== id) return row;
          const replaced = {
            ...row,
            item,
            values
          };
          delete replaced.$$hashKey;
          return replaced;
        });
        formatRows(data);
        updateFiltered();
      });
    }
  });
  async function activate() {
    const {
      vm
    } = $scope;
    const {
      id
    } = $stateParams;
    vm.me = await userService.me();
    vm.vueFilters = await resolveReportFilterPanel(userService, leanLawAuth.features);
    if (vm.initialDateRange) {
      const {
        periodOptions
      } = reportFilterService.options();
      const dateRange = periodOptions.find(p => p.id === vm.initialDateRange || p.label === vm.initialDateRange);
      reportFilterService.setFilterState({
        dateRange
      });
    }
    vm.report = reportDefinitions[id];
    if (!vm.report) {
      throw Error(`wat, no report called '${id}'? check the reportDefinitions.js file`);
    }
    _params = {
      ...vm.report.params,
      ...$stateParams
    };
    vm.structure = vm.report.definition.structure({
      params: _params,
      me: vm.me
    });
    vm.title = vm.report.label;
    vm.returnLabel = $stateParams.returnLabel;
    vm.menu = vm.report.menu || vm.report.definition.menu;
    vm.selectable = vm.report.select || vm.report.definition.select;
    vm.sort = vm.structure.sort;
    vm.subrows = vm.structure.subrow?.label && vm.structure.subrow.default;
    updateColumns();
    $scope.$watch("vm.filter", (newValue, oldValue) => {
      if (!oldValue || newValue === oldValue) return;
      updateColumns();
      filterChanged();
    }, true);
    $scope.$watch("search", updateFiltered);
    $scope.$watchGroup(["vm.sort", "vm.reverse", "vm.subrows"], updateFiltered);
    if (!vm.filter.initialize) {
      filterChanged();
    }
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    const {
      report
    } = $scope.vm;
    if (report) {
      report.definition.cancel(_params);
    }
    deactivate();
  });
  async function filterChanged() {
    const {
      vm
    } = $scope;
    // The Vue panel only applies filters this report shows; the legacy one sends all.
    const filter = vm.vueFilters ? reportFilterService.getVisibleFilterState(vm.structure.showFilters) : reportFilterService.getFilterState();
    const {
      definition
    } = vm.report;
    if (definition.filterChange) {
      var actions = definition.filterChange({
        filter
      });
      if (actions?.navigate) {
        var params = {
          ...$stateParams,
          ...actions.navigate
        };
        console.log('navigating', params);
        return $state.go('reports.generic', params);
      }
    }
    vm.loading = true;
    try {
      const query = reportFilterService.queryFromFilter(vm.structure.showFilters, vm.vueFilters);
      vm.data = await definition.load({
        query,
        filter,
        columns: vm.structure.columns,
        params: _params,
        me: vm.me
      });
      if (vm.data) {
        formatReportData(vm.data);
        updateFiltered();
        vm.loading = false;
      }
    } catch (err) {
      alerts.error(err);
      vm.loading = false;
    }
    $scope.$apply();
  }
  function formatDate(date) {
    return $filter("dateStandard")(new Date(date));
  }
  function formatReportData(data) {
    formatRows(data);
  }
  function formatRows(data) {
    // 1. updates cell.display according to column format
    // 2. calculates totals
    const {
      columns
    } = $scope.vm.structure;
    if (!data.rows) return;
    data.rows.forEach(row => {
      columns.forEach(column => {
        const cell = row.values[column.id];
        if (!cell) {
          console.error(`Couldnt find cell for column '${column.id}' - verify that your load() function returns the columns defined in the report structure spec`);
        }
        cell.display = displayValue(cell.value, column);
      });

      // recurse through nested rows
      formatRows(row);
    });
    calculateTotals(data);
  }
  function calculateTotals(data) {
    const {
      columns,
      totals
    } = $scope.vm.structure;
    if (totals.rows) {
      data.totals = {
        values: {}
      };
      columns.forEach(c => {
        const total = !c.number ? undefined : data.rows.reduce((sum, r) => sum + (r.values[c.id].value || 0), 0);
        data.totals.values[c.id] = {
          value: total,
          display: displayValue(total, c)
        };
      });
    }
    if (data.extraTotal) {
      columns.forEach(c => {
        var cell = data.extraTotal.values[c.id];
        if (cell) {
          cell.display = displayValue(cell.value, c);
        }
      });
    }
  }
  function showBasedOnFilter(columns, exporting) {
    if (!columns) return;
    return columns.filter(col => col.show === undefined ? true : col.show($scope.vm.filter, exporting));
  }
  function updateColumns() {
    const {
      vm
    } = $scope;
    vm.columns = showBasedOnFilter(vm.structure.columns) || [];
    vm.totalColumns = vm.columns.slice(vm.structure.totals.totalLabelCells);
  }
  function updateFiltered() {
    const {
      vm
    } = $scope;
    const rows = vm.data && vm.data.rows;
    if (!rows) {
      vm.filtered = [];
      return;
    }
    const arrange = list => $filter('orderByColumn')($filter('filter')(list, $scope.search), vm.sort, vm.reverse);
    vm.filtered = arrange(rows);
    vm.filtered.forEach(row => {
      row.filteredRows = vm.subrows && row.rows ? arrange(row.rows) : undefined;
    });
  }
  function displayValue(value, column) {
    return column.filter ? $filter(column.filter)(value) : value;
  }
  function exportReport() {
    const {
      structure,
      data,
      sort,
      reverse
    } = $scope.vm;
    const columnList = showBasedOnFilter(structure.columns, true);
    const csv = [];
    $filter('orderByColumn')(data.rows, sort, reverse).forEach(row => {
      if (!structure.export?.flatten) {
        if (structure.subrow?.title) {
          csv.push({
            [columnList[0].label]: row.label
          });
        } else {
          csv.push(columnList.reduce((acc, c) => {
            const {
              label,
              id
            } = c;
            let value = row.values[id].display;
            if (value && id === 'date') value = $filter('dateStandard')(value);
            const key = label === 'Client/Matter' ? 'Client' : label;
            acc[key] = value;
            return acc;
          }, {}));
        }
      }
      if ($scope.vm.subrows) {
        $filter('orderByColumn')(row.rows, sort, reverse).forEach(matter => {
          csv.push(columnList.reduce((acc, c) => {
            const {
              label,
              id
            } = c;
            let value = matter.values[id].display;
            if (value && id === 'date') value = $filter('dateStandard')(value);
            const key = label === 'Client/Matter' ? 'Matter' : label;
            acc[key] = value;
            return acc;
          }, {}));
        });
      }
      if (structure.subrow?.title && !structure.export?.flatten) {
        var subtotal = exportTotals(columnList, row, 'Total');
        csv.push(subtotal);
        csv.push({
          [columnList[0].label]: ''
        });
      }
    });
    if (data.totals) {
      var total = exportTotals(columnList, data.totals, structure.subrow?.title ? 'Grand Total' : 'Total');
      csv.push(total);
    }
    exportJson.downloadCsv(csv, 'Reports');
  }
  function exportTotals(columnList, row, label) {
    const total = {
      [columnList[0].label]: label
    };
    columnList.slice(1).reduce((acc, c) => {
      if (c.total !== false) {
        acc[c.label] = row.values[c.id].display;
      }
      return acc;
    }, total);
    return total;
  }
  function selectRow(row, subrow) {
    const {
      selectable
    } = $scope.vm;
    if (!selectable || row.nonSelectable) {
      return;
    }
    const dest = selectable(row, subrow, _params);
    if (!dest) {
      return;
    }
    const params = {
      ...$stateParams,
      ...dest.params,
      returnRoute: $state.current.name,
      returnParams: $stateParams,
      // clear the initial daterange
      dateRangeId: undefined,
      // legacy
      return: $state.current.name,
      backParams: $stateParams
    };
    if (dest.report) {
      params.id = dest.report;
    }
    $state.go(dest.route || `reports.generic`, params);
  }
  function goback() {
    $state.go($stateParams.returnRoute, $stateParams.returnParams);
  }
}]);